import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Container } from 'reactstrap';

import Navbar from './ui/Navbar';
import Footer from './ui/Footer';
import Contact from './pages/Contact';
import GallaryCategory from './pages/GallaryCategory';

class App extends Component {
  render() {
    const homeContext = require.context(
      './photos/home/',
      false,
      /\.(png|jpe?g|gif)$/i
    );
    // const filmContext = require.context(
    //   './photos/film/',
    //   false,
    //   /\.(png|jpe?g|gif)$/i
    // );
    const portraitureContext = require.context(
      './photos/portraiture/',
      false,
      /\.(png|jpe?g|gif)$/i
    );
    const koreaContext = require.context(
      './photos/korea/',
      false,
      /\.(png|jpe?g|gif)$/i
    );
    const caliContext = require.context(
      './photos/cali/',
      false,
      /\.(png|jpe?g|gif)$/i
    );
    const creepyContext = require.context(
      './photos/creepy/',
      false,
      /\.(png|jpe?g|gif)$/i
    );

    return (
      <div id="App">
        <Container fluid id="container-main">
          <span id="content">
            <Navbar />
            <hr />
            <Switch>
              <Route
                exact
                path="/"
                render={() => (
                  <GallaryCategory key="home" context={homeContext} />
                )}
              />
              {/* <Route
                exact
                path="/film"
                render={() => (
                  <GallaryCategory key="film" context={filmContext} />
                )}
              /> */}
              <Route
                exact
                path="/portraiture"
                render={() => (
                  <GallaryCategory
                    key="portraiture"
                    context={portraitureContext}
                  />
                )}
              />
              <Route
                exact
                path="/south_korea"
                render={() => (
                  <GallaryCategory key="korea" context={koreaContext} />
                )}
              />
              <Route
                exact
                path="/california"
                render={() => (
                  <GallaryCategory key="cali" context={caliContext} />
                )}
              />
              <Route
                exact
                path="/creepy"
                render={() => (
                  <GallaryCategory key="creepy" context={creepyContext} />
                )}
              />
              <Route exact path="/contact" component={Contact} />
            </Switch>
          </span>
          <Footer />
        </Container>
      </div>
    );
  }
}

const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);
export default AppWithRouter;
